/* eslint-disable */
"use strict";

import Vue from "vue";
import axios from "axios";
import store from "@/store";
import { message } from "ant-design-vue";

export const URL = {
  production: {
    test: {
      auth_api: "http://testapi.asanmuraciet.gov.az/amurregistration/v1/",
      service_api: "http://testapi.asanmuraciet.gov.az/easyappeal/v1/",
      file_url: "http://testapi.asanmuraciet.gov.az/files/",
      chat_service_api: "http://localhost:8081",
      auth_origin: "http://tmreg.asan.org",
      auth_main_page_origin: "http://tmreg.asan.org",
      auth_exec_page_origin: "http://tmreg.asan.org",
      socket_origin: "http://10.60.20.22:80",
      // socket_origin:"http://10.93.30.138:80"
    },
    prod: {
      //main
      auth_api: "https://execapi.asanmuraciet.gov.az/amurregistration/v1/",
      service_api: "https://execapi.asanmuraciet.gov.az/easyappeal/v1/",
      file_url: "https://execapi.asanmuraciet.gov.az/files/",
      chat_service_api: "https://localhost:8081",
      auth_origin: "https://accounts.asanmuraciet.gov.az/main",
      auth_main_page_origin: "https://accounts.asanmuraciet.gov.az/main",
      auth_exec_page_origin: "https://accounts.asanmuraciet.gov.az/main",
      socket_origin: "https://node.asanmuraciet.gov.az",
    },
  }[process.env.VUE_APP_TITLE],
  /*   
  production: {
    auth_api: "http://testapi.asanmuraciet.gov.az/amurregistration/v1/",
    service_api: "http://testapi.asanmuraciet.gov.az/easyappeal/v1/",
    file_url: "http://testapi.asanmuraciet.gov.az/files/",
    chat_service_api: "http://localhost:8081",
    auth_origin: "http://tmreg.asan.org",
    auth_main_page_origin: "http://tmreg.asan.org",
    auth_exec_page_origin: "http://tmreg.asan.org",
    socket_origin: "http://10.60.20.22:80",
    // socket_origin:"http://10.93.30.138:80"
  },
/*   production: {
    //main
      auth_api: "https://execapi.asanmuraciet.gov.az/amurregistration/v1/",
      service_api: "https://execapi.asanmuraciet.gov.az/easyappeal/v1/",
      file_url: "https://execapi.asanmuraciet.gov.az/files/",
      chat_service_api: "https://localhost:8081",
      auth_origin: "https://accounts.asanmuraciet.gov.az/main",
      auth_main_page_origin: "https://accounts.asanmuraciet.gov.az/main",
      auth_exec_page_origin: "https://accounts.asanmuraciet.gov.az/main",
      socket_origin: "https://node.asanmuraciet.gov.az",
    }, */

  /* 
  development: {
    auth_api: "http://testapi.asanmuraciet.gov.az/amurregistration/v1/",
    service_api: "http://testapi.asanmuraciet.gov.az/easyappeal/v1/",
    file_url: "http://testapi.asanmuraciet.gov.az/files/",
    chat_service_api: "http://localhost:8081",
    auth_origin: "https://accounts.muraciet.az/main",
    auth_main_page_origin: "https://accounts.muraciet.az/main",
    auth_exec_page_origin: "https://accounts.muraciet.az/main",
    socket_origin: "http://10.60.20.22:80",
    // socket_origin:"http://10.93.30.138:80"
  } , */

  // testing
  /* requests/story/ */

  /* requests/story/ */
  development: {
    auth_api: "http://testapi.asanmuraciet.gov.az/amurregistration/v1/",
    service_api: "http://testapi.asanmuraciet.gov.az/easyappeal/v1/",
    file_url: "http://testapi.asanmuraciet.gov.az/files/",
    chat_service_api: "http://localhost:8081",
    auth_origin: "http://tmreg.asan.org",
    auth_main_page_origin: "http://tmreg.asan.org",
    auth_exec_page_origin: "http://tmreg.asan.org",
    socket_origin: "http://10.60.20.22:80",
    // socket_origin:"http://10.93.30.138:80"
  },

  /* development: {
    auth_api: "http://10.60.20.22:8080/amurregistration/v1/",
    service_api: "http://localhost:8081/v1/",
    file_url: "http://10.60.20.22:8080/files/",
    chat_service_api: "http://localhost:8081",
    auth_origin: "http://mreg.asan.org/",
    auth_main_page_origin: "http://mreg.asan.org/main",
    auth_exec_page_origin: "http://mreg.asan.org/executive",
    socket_origin: "http://10.60.20.22:80",
    // socket_origin:"http://10.93.30.138:80"
  } ,

 production: {
    auth_api: "http://10.60.20.22:8080/amurregistration/v1/",
    service_api: "http://10.60.20.22:8080/easyappeal/v1/",
    file_url: "http://10.60.20.22:8080/files/",
    chat_service_api: "http://localhost:8081",
    auth_origin: "http://mreg.asan.org/",
    auth_main_page_origin: "http://mreg.asan.org/main",
    auth_exec_page_origin: "http://mreg.asan.org/executive",
    socket_origin: "http://10.60.20.22:80",
    // socket_origin:"http://10.93.30.138:80"
  },

  production: {
    auth_api: "https://execapi.muraciet.az/amurregistration/v1/",
    service_api: "https://execapi.muraciet.az/easyappeal/v1/",
    file_url: "https://execapi.muraciet.az/files/",
    chat_service_api: "https://localhost:8081",
    auth_origin: "https://accounts.muraciet.az/",
    auth_main_page_origin: "https://accounts.muraciet.az/main",
    auth_exec_page_origin: "https://accounts.muraciet.az/executive",
    socket_origin: "https://node.muraciet.az",
  },*/
};

export const apiCall = async ({ url, method, ignoreToken, ...args }) =>
  await new Promise(async (resolve, reject) => {
    axios.defaults.headers.common["Content-Type"] = "application/json";
    axios.defaults.headers.common["Accept-Language"] = "az";
    axios.defaults.headers.common["StepId"] = sessionStorage.getItem(
      "userGroupType"
    );

    if (!ignoreToken) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + Vue.cookie.get("ASAN-APPEAL-TOKEN");
    }
    if (process.env.NODE_ENV == "development") {
      console.log(url + " " + method);
      //console.log(axios.defaults.headers);
    }
    try {
      await axios({
        method: method || "GET",
        url: url,
        ...args,
      })
        .then((response) => {
          // common place for all rest apis
          resolve(response);
        })
        .catch((error) => {
          if (error.message == "Network Error") {
            message.error("Serverə qoşulmaq mümkün olmadı");
            reject(error);
            return;
          }
          if (error.response && error.response.status === 401) {
            store
              .dispatch("user/logout")
              .then(() => {
                return (window.location.href =
                  URL[process.env.NODE_ENV].auth_exec_page_origin);
              })
              .catch(() => {
                return (window.location.href =
                  URL[process.env.NODE_ENV].auth_exec_page_origin);
              });
          }
          message.error("Serverdə xəta baş verdi");
          console.log(error);
          reject(error);
        });
    } catch (error) {
      reject(new Error(error));
    }
  });
